

const generateProductTileMarkup = variant => {
  const { price, image, flavour_tags, tasting_notes, product_title } = variant; // This one should be used once the correct images have been added to the relevant image metaifelds on the bundle variants
  // const variantImage = variant.featured_media.preview_image.src;

  return /*html*/`
    <style>

      .bundle-product-tile {
        border-top: 0.0625rem solid rgba(18, 50, 71, 0.12);
        margin: 0 2.5rem;
      }

      .top-row {
        display: flex;
        padding: 1.75rem 0 0;
      }

      .image {
        max-width: 2.6223rem;
        height: 4.25rem;
        object-fit: contain;
      }

      .text-container {
        padding-left: 1.375rem;
        padding-right: 0.625rem;
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
      }

      .title {
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 485;
        line-height: 1.625rem;
        letter-spacing: 0.025rem;
        margin: 0;
      }

      .tasting-notes {
        font-family: var(--font-secondary);
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.125rem;
        margin: 0;
      }

      .tasting-notes.condensed {}

      .tasting-notes.full {
        display: none;
      }

      .bundle-product-tile.is-expanded .tasting-notes.condensed {
        display: none;
      }

      .bundle-product-tile.is-expanded .tasting-notes.full {
        display: block;
      }

      .read-more, .read-less {
        background-color: transparent;
        border: none;
        color: var(--transparent-navy-navy-40);
        font-family: var(--font-secondary);
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.125rem;
        padding: 0;
      }

      .price {
        color: var(--transparent-navy-navy-40);
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1rem;
        letter-spacing: 0.135rem;
        margin: 0;
      }

      .button-container {

      }

      .atc-button {
        background-color: var(--opaque-lark-navy);
        border-radius: 50%;
        border: none;
        height: 1.5rem;
        width: 1.5rem;
        position: relative;
      }

      .bundle-product-tile.active .atc-button::after {
        content: '';
        width: 0.625rem;
        height: 0.0625rem;
        background-color: var(--color-white);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      } 

      .bundle-product-tile.active .atc-button::before {
        content: none;
      }

      .atc-button::before {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 12 12'%3E%3Cpath stroke='%23fff' stroke-linecap='square' stroke-linejoin='round' d='M6 2.5v7M2.5 6h7'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        width: 0.75rem;
        height: 0.75rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .bottom-row {
        padding: 1.125rem 0 1.5rem;
        text-align: left;
      } 

      .tags {
        display: flex;
        flex-wrap: wrap;
      }
      .tag {
        border: 0.0625rem solid var(--transparent-navy-navy-12);
        border-radius: 3rem;
        color: var(--transparent-navy-navy-40);
        font-size: 0.65rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1rem;
        letter-spacing: 0.135rem;
        padding: 0.375rem 1rem;
        text-transform: uppercase;
        margin: 0.2rem;
        text-wrap: no-wrap;
      }

      @media screen and (max-width: 991px) {
        .bundle-product-tile {
          margin: 0;
        }

        .text-container {
          width: 100%;
        }
      }
    </style>


    <div class="bundle-product-tile">
      <div class="top-row">
        <img class="image" src="${image}">
        <div class="text-container">
          <h3 class="title">${product_title}</h3>
          <p class="tasting-notes condensed">
            ${tasting_notes.substr(0, 60)}...
            <button class="read-more">Read more</button>
          </p>

          <p class="tasting-notes full">
          ${tasting_notes}
          <button class="read-less">Read less</button>
        </p>

          <p class="price">$${(price / 100).toFixed(2)}</p>

        </div>

        <div class="button-container">
          <button class="atc-button" add-to-cart></button>
        </div>
      </div>
      <div class="bottom-row">
        <span class="tags">
          ${flavour_tags.map(tag => {
            return `<p class="tag">${tag}</p>`
          }).join('')}
        </span>
      </div>
    </div>
  `
}

export class BundleProductTile extends HTMLElement {

  public readonly variant:{
    id: string;
  }

  private variantIsSelected:boolean = false;
  private readonly root:HTMLDivElement|null;
  private addToCartButton:HTMLElement;
  private readMoreBtn:HTMLElement;
  private readLessBtn:HTMLElement;

  constructor() {
    super();

    this.variant = JSON.parse(this.getAttribute('variant') || '{}');

    this.variantIsSelected = false;

    const template = document.createElement('template');
    template.innerHTML = generateProductTileMarkup(this.variant)

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.bundle-product-tile')!;
    this.addToCartButton = shadowRoot.querySelector('[add-to-cart]')!;
    this.readMoreBtn = shadowRoot.querySelector('.read-more')!;
    this.readLessBtn = shadowRoot.querySelector('.read-less')!;

    this.addToCartButton.addEventListener('click', this.handleAddToCartClick.bind(this));

    this.readMoreBtn.addEventListener('click', () => this.setExpanded(true))
    this.readLessBtn.addEventListener('click', () => this.setExpanded(false))
  }

  setExpanded(isExpanded:boolean) {
    this.root?.classList[isExpanded ? 'add' : 'remove']('is-expanded');
  }

  setActive(isActive:boolean) {
    this.variantIsSelected = isActive;
    this.root?.classList[this.variantIsSelected ? 'add' : 'remove']('active')
  }

  handleAddToCartClick() {
    const eventType = this.variantIsSelected ? 'product_remove' : 'product_select';

    const event = new CustomEvent(eventType, { 
      detail: {
        ctx: this
      }, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }
}

if(!customElements.get('bundle-product-tile')) {
  customElements.define('bundle-product-tile', BundleProductTile);
}